import { Module } from '@nestjs/common';
import { MasterBrandsController } from './master-brands.controller';
import { MasterBrand } from './master-brands.entity';
import { MasterBrandsService } from './master-brands.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { MasterBrandAdapter } from './dto/master-brands.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Brands } from '../end-customer/brands.entity';



@Module({
  imports: [
    TypeOrmModule.forFeature([MasterBrand,Brands]),
  ],
  controllers: [MasterBrandsController],
  providers: [MasterBrandsService,MasterBrandAdapter,ApplicationExceptionHandler,LogsService],
  exports:[MasterBrandsService]
})
export class MasterBrandsModule {}
